var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.756 155L79.9051 145.625L55.2441 155L66.9629 108.125H93.0373L104.756 155Z",
    fill: "#D5DDE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 145.661L104.756 155L93.0372 108.125H80V145.661Z",
    fill: "#B0BFC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160 117.5H0V5H160V117.5Z",
    fill: "#ECEFF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 5H160V117.5H80V5Z",
    fill: "#D5DDE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 14.375H150.625V108.125H9.375V14.375Z",
    fill: "#365D93"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80 14.375H150.625V108.125H80V14.375Z",
    fill: "#284064"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8125 145.625H122.188V155H37.8125V145.625Z",
    fill: "#D5DDE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80 145.625H122.188V155H80V145.625Z",
    fill: "#B0BFC9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5035 51.0694L65.1319 44.441L58.5035 37.8125L65.1319 31.1841L58.5035 24.5557L51.875 31.1841L45.2466 24.5557L38.6182 31.1841L45.2466 37.8125L38.6182 44.441L45.2466 51.0694L51.875 44.441L58.5035 51.0694Z",
    fill: "#FF6591"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.382 31.1841L114.753 24.5557L108.125 31.1841L101.497 24.5557L94.8682 31.1841L101.497 37.8125L94.8682 44.441L101.497 51.0694L108.125 44.441L114.753 51.0694L121.382 44.441L114.753 37.8125L121.382 31.1841Z",
    fill: "#F31260"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80 61.25C61.9091 61.25 47.1875 75.9716 47.1875 94.0625V98.75H56.5625V94.0625C56.5625 81.1397 67.0772 70.625 80 70.625C92.9228 70.625 103.438 81.1397 103.438 94.0625V98.75H112.812V94.0625C112.812 75.9716 98.0909 61.25 80 61.25Z",
    fill: "#FF6591"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.438 94.0625V98.75H112.812V94.0625C112.812 75.9716 98.0909 61.25 80 61.25V70.625C92.9228 70.625 103.438 81.1397 103.438 94.0625Z",
    fill: "#F31260"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/errorImage.d928f5831f3de3d2a460e0b2e39c8f1a.svg";
export { ForwardRef as ReactComponent };